import controller from './advertisement.controller';
import templateBase from './templates/advertisement.view.html';
import templateT1 from './templates/advertisement-t1.view.html';
import templateAD from './templates/advertisement.adaptative.view.html';

let AdvertisementComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        typeContent: '@',
        positions:'@',
        pageName:'@',
        contentData:'<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  if (__env.adaptative) {
  return templateAD;
  } else {
    if (response.CMS.component == 'template_t1') { return templateT1; } 
    else if (response.CMS.component == 'template_t3') 
    { return templateT1; } else{
        return templateBase;
    }
  
  }
  
  }

export default AdvertisementComponent;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/shared/components/advertisement/advertisement.component.js
 **/